// ==================== SUBSCRIPTION HELPERS ====================

import type { Subscription } from '../types';

/**
 * Check if subscription has valid access
 * - ACTIVE: always has access
 * - CANCELLED: has access until currentPeriodEnd date
 * - EXPIRED/PENDING: no access
 */
export const hasValidSubscriptionAccess = (subscription?: Subscription | null): boolean => {
  if (!subscription) return false;

  // ACTIVE subscription always has access
  if (subscription.status === 'ACTIVE') return true;

  // CANCELLED subscription has access until currentPeriodEnd
  if (subscription.status === 'CANCELLED') {
    const now = new Date();
    const periodEnd = new Date(subscription.currentPeriodEnd);
    return periodEnd > now;
  }

  // EXPIRED or PENDING have no access
  return false;
};
